import { enableProdMode, isDevMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { Environment } from './environments/environment';

// Must run before enableProdMode(): isDevMode() has to reflect the build-time flag
// (unoptimized build), not the runtime environment. Dev builds don't ship a service
// worker, so any worker left over from a previous session would serve stale bundles.
if (isDevMode() && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => registrations.forEach((registration) => registration.unregister()));
}

if (Environment.environmentStatus === 'prod') {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));

// Call the element loader after the platform has been bootstrapped
defineCustomElements(window);
